import { loader } from 'graphql.macro';

export const fieldStateFragment = loader('./fragments/fieldState.graphql');
export const templateMetadataFragment = loader('./fragments/templateMetadata.graphql');

export const getFieldStateById = loader('./queries/getFieldStateById.graphql');
export const listFieldsState = loader('./queries/listFieldsState.graphql');
export const setFieldState = loader('./mutations/setFieldState.graphql');

export const listFieldsForCategory = loader('./queries/listFieldsForCategory.graphql');
export const listTemplateFieldsForCategory = loader('./queries/listTemplateFieldsForCategory.graphql');
export const listAssessments = loader('./queries/listAssessments.graphql');
export const getAssessmentById = loader('./queries/getAssessmentById.graphql');
export const getAssessmentLanguagesById = loader('./queries/getAssessmentLanguagesById.graphql');

export const getTemplates = loader('./queries/getTemplates.graphql');
export const getDomainRestrictedTemplates = loader('./queries/getDomainRestrictedTemplates.graphql');
export const getSubmittedTemplates = loader('./queries/getSubmittedTemplates.graphql');
export const getTemplateById = loader('./queries/getTemplateById.graphql');
export const getTemplateLanguagesById = loader('./queries/getTemplateLanguagesById.graphql');

export const updateActiveUsers = loader('./mutations/updateActiveUsers.graphql');
export const updateAssessmentEvent = loader('./mutations/updateAssessmentEvent.graphql');
export const deleteAssessmentEvent = loader('./mutations/deleteAssessmentEvent.graphql');
export const updateAssessmentStatus = loader('./mutations/updateAssessmentStatus.graphql');
export const getAssessmentEventById = loader('./queries/getAssessmentEventById.graphql');
export const getLatestAssessmentEventById = loader('./queries/getLatestAssessmentEventById.graphql');
export const getLatestTemplateEventById = loader('./queries/getLatestTemplateEventById.graphql');
export const listAssessmentEvents = loader('./queries/listAssessmentEvents.graphql');

export const getCurrentUser = loader('./queries/getCurrentUser.graphql');
export const listUsers = loader('./queries/listUsers.graphql');
export const getUserByEmail = loader('./queries/getUserByEmail.graphql');
export const getInvalidFields = loader('./queries/getInvalidFields.graphql');
export const getInvalidTemplateFields = loader('./queries/getInvalidTemplateFields.graphql');
export const getActiveUsers = loader('./queries/getActiveUsers.graphql');

export const inviteUser = loader('./mutations/inviteUser.graphql');
export const addUser = loader('./mutations/addUser.graphql');
export const updateUserProfile = loader('./mutations/updateUserProfile.graphql');
export const removeCurrentUser = loader('./mutations/removeCurrentUser.graphql');
export const addParticipantToAssessment = loader('./mutations/addParticipantToAssessment.graphql');
export const removeParticipantFromAssessment = loader('./mutations/removeParticipantFromAssessment.graphql');
export const removeCurrentUserFromAssessment = loader('./mutations/removeCurrentUserFromAssessment.graphql');
export const setCurrentUser = loader('./mutations/currentUser.graphql');
export const submitAssessment = loader('./mutations/submitAssessment.graphql');
export const submitTemplateRecord = loader('./mutations/submitTemplateRecord.graphql');
export const updateAssigneesForCategory = loader('./mutations/updateAssigneesForCategory.graphql');
export const setAssigneesForField = loader('./mutations/setAssigneesForField.graphql');
export const setRoleForParticipant = loader('./mutations/setRoleForParticipant.graphql');
export const updateUserStatus = loader('./mutations/updateUserStatus.graphql');
export const userOpenAssessment = loader('./mutations/userOpenAssessment.graphql');
export const userCloseAssessment = loader('./mutations/userCloseAssessment.graphql');
export const userOpenTemplate = loader('./mutations/userOpenTemplate.graphql');
export const userCloseTemplate = loader('./mutations/userCloseTemplate.graphql');

export const updateDateFieldValue = loader('./mutations/questions/updateDateFieldValue.graphql');
export const updateNumericFieldValue = loader('./mutations/questions/updateNumericFieldValue.graphql');
export const updateTextFieldValue = loader('./mutations/questions/updateTextFieldValue.graphql');
export const updateValuesListFieldValue = loader('./mutations/questions/updateValuesListFieldValue.graphql');
export const userStartTyping = loader('./mutations/userStartTyping.graphql');
export const userStopTyping = loader('./mutations/userStopTyping.graphql');

export const getDDEActions = loader('./queries/getDDEActions.graphql');
export const getDDEDetails = loader('./queries/getDDEDetails.graphql');
export const getDDEDetailsForTemplate = loader('./queries/getDDEDetailsForTemplate.graphql');
export const getTemplateDDEActions = loader('./queries/getTemplateDDEActions.graphql');
export const ddeActionsTriggered = loader('./mutations/ddeActionsTriggered.graphql');
export const templateDdeActionsTriggered = loader('./mutations/templateDdeActionsTriggered.graphql');
export const updateTemplateDateFieldValue = loader('./mutations/questions/updateTemplateDateFieldValue.graphql');
export const updateTemplateNumericFieldValue = loader('./mutations/questions/updateTemplateNumericFieldValue.graphql');
export const updateTemplateTextFieldValue = loader('./mutations/questions/updateTemplateTextFieldValue.graphql');
export const updateTemplateValuesListFieldValue = loader('./mutations/questions/updateTemplateValuesListFieldValue.graphql');
export const templateStartTyping = loader('./mutations/templateStartTyping.graphql');
export const templateStopTyping = loader('./mutations/templateStopTyping.graphql');

export const removeAttachment = loader('./mutations/questions/removeAttachment.graphql');
export const removeTemplateAttachment = loader('./mutations/questions/removeTemplateAttachment.graphql');
export const getAttachmentUploadToken = loader('./mutations/questions/getAttachmentUploadToken.graphql');
export const getTemplateAttachmentUploadToken = loader('./mutations/questions/getTemplateAttachmentUploadToken.graphql');
export const publishAttachment = loader('./mutations/questions/publishAttachment.graphql');
export const publishTemplateAttachment = loader('./mutations/questions/publishTemplateAttachment.graphql');
export const checkAttachmentUploadStatus = loader('./mutations/questions/checkAttachmentUploadStatus.graphql');
export const checkTemplateAttachmentUploadStatus = loader('./mutations/questions/checkTemplateAttachmentUploadStatus.graphql');
export const getAttachmentDownloadToken = loader('./mutations/questions/getAttachmentDownloadToken.graphql');
export const getTemplateAttachmentDownloadToken = loader('./mutations/questions/getTemplateAttachmentDownloadToken.graphql');

export const onAssessmentEvent = loader('./subscriptions/onAssessmentEvent.graphql');
export const onTemplateEvent = loader('./subscriptions/onTemplateEvent.graphql');

export const getCommentMetadata = loader('./queries/getCommentMetadata.graphql');
export const listCommentsForField = loader('./queries/listCommentsForField.graphql');
export const saveComment = loader('./mutations/comments/saveComment.graphql');
export const removeComment = loader('./mutations/comments/removeComment.graphql');

export const clearOktaSession = loader('./mutations/clearOktaSession.graphql');

const Operations = {
  fragments: {
    fieldStateFragment,
    templateMetadataFragment
  },
  queries: {
    listFieldsForCategory,
    listTemplateFieldsForCategory,
    getFieldStateById,
    listFieldsState,
    listAssessments,
    getAssessmentById,
    getAssessmentLanguagesById,
    getCurrentUser,
    listUsers,
    getUserByEmail,
    getInvalidFields,
    getInvalidTemplateFields,
    getAssessmentEventById,
    getDDEActions,
    getDDEDetails,
    getDDEDetailsForTemplate,
    getTemplateDDEActions,
    getTemplates,
    getDomainRestrictedTemplates,
    getSubmittedTemplates,
    getTemplateById,
    listCommentsForField,
    getCommentMetadata
  },
  mutations: {
    setFieldState,
    setCurrentUser,
    submitAssessment,
    submitTemplateRecord,
    updateAssigneesForCategory,
    setAssigneesForField,
    updateDateFieldValue,
    updateNumericFieldValue,
    updateTextFieldValue,
    updateTemplateTextFieldValue,
    updateTemplateDateFieldValue,
    updateTemplateNumericFieldValue,
    updateTemplateValuesListFieldValue,
    updateValuesListFieldValue,
    getAttachmentUploadToken,
    getTemplateAttachmentUploadToken,
    checkAttachmentUploadStatus,
    checkTemplateAttachmentUploadStatus,
    publishAttachment,
    publishTemplateAttachment,
    getAttachmentDownloadToken,
    getTemplateAttachmentDownloadToken,
    removeAttachment,
    removeTemplateAttachment,
    inviteUser,
    addUser,
    updateUserProfile,
    removeCurrentUser,
    addParticipantToAssessment,
    removeParticipantFromAssessment,
    removeCurrentUserFromAssessment,
    setRoleForParticipant,
    updateUserStatus,
    userOpenAssessment,
    userCloseAssessment,
    ddeActionsTriggered,
    templateDdeActionsTriggered,
    userOpenTemplate,
    userCloseTemplate,
    clearOktaSession,
    saveComment,
    removeComment
  },
  subscriptions: {
    onAssessmentEvent,
    onTemplateEvent
  }
};

export default Operations;
